import { Box, Container } from '@mui/material';

const PageLayout = ({
  children,
  maxWidth = '1180px',
  centerContent = false,
  paddingTop = { xs: '30px', lg: '50px' },
  paddingBottom = { xs: '50px', lg: '100px' },
}) => {
  return (
    <Box
      component="main"
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          width: '100%',
          px: { xs: 2.5, md: 3 },
          display: 'flex',
          justifyContent: 'center',
          alignItems: centerContent ? 'center' : 'flex-start',
        }}
      >
        <Box sx={{ maxWidth, width: '100%', mx: 'auto' }}>
          <Box sx={{ pt: paddingTop, pb: paddingBottom }}>{children}</Box>
        </Box>
      </Container>
    </Box>
  );
};

export default PageLayout;
